import styled from 'styled-components';
import { H2, Container as ContainerComponent } from '../../theme/layout';
import { title } from '../../theme/typography';
import { colors } from '../../theme/styled';
import { media } from '../../theme/media';

export const Title = styled(H2)`
  ${title};
  color: ${colors.white};
  font-size: 16px;
  line-height: 1.25;
  letter-spacing: 0.9px;
  margin-bottom: 12px;
`;


export const Container = styled(ContainerComponent)`
  margin-bottom: 32px;
  margin-top: 26px;
  align-items: flex-start;
  padding-left: 24px;
  padding-right: 24px;
  padding-top: 24px;
  margin-top: 24px;
  border-top: 1px solid rgba(255,255,255,0.1);
  
  ${media.tablet`
    border: 0;
    margin: 0 0 24px;
    padding: 0;
  `};

  ${media.tabletLarge`
    margin: 40px 0 0 0;
  `};
  
  address a:hover,
  address a:focus {
    outline: none;
    text-decoration: underline;
  }
`;
